import { FC } from 'react'

import { ChannelForAllocatedList } from '../../../types/inventoryAllocatedList'
import InventoryRatePlanRow from './InventoryRatePlanRowMobile'

interface InventoryTableRatePlanProps {
  channelData: ChannelForAllocatedList
}
const InventoryTableRatePlan: FC<InventoryTableRatePlanProps> = ({
  channelData
}) => {
  return (
    <>
      <InventoryRatePlanRow
        channelDataForEachDay={channelData.detailsForEachDate}
      />
    </>
  )
}

export default InventoryTableRatePlan
